import { render, staticRenderFns } from "./PageSolve.vue?vue&type=template&id=51e2dd1b&scoped=true"
import script from "./PageSolve.vue?vue&type=script&lang=js"
export * from "./PageSolve.vue?vue&type=script&lang=js"
import style0 from "./PageSolve.vue?vue&type=style&index=0&id=51e2dd1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2dd1b",
  null
  
)

export default component.exports